// src/pages/Register.jsx — Epic Games Store style
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { register } from "../services/authService";

const S = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
*, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
.auth-pg { min-height:100vh; background:#121212; display:flex; font-family:'Inter',sans-serif; }

.auth-left { flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px 40px; position:relative; overflow:hidden; }
.auth-left-bg { position:absolute; inset:0; background:linear-gradient(135deg,#0d1b2e 0%,#121212 60%); }
.auth-left-glow { position:absolute; top:-10%; left:-10%; width:60%; padding-top:60%; background:radial-gradient(circle, rgba(0,120,242,0.16) 0%,transparent 70%); pointer-events:none; }
.auth-left-grid { position:absolute; inset:0; background-image:linear-gradient(rgba(255,255,255,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.025) 1px,transparent 1px); background-size:40px 40px; }
.auth-left-content { position:relative; z-index:2; max-width:400px; width:100%; }

.auth-logo { display:flex; align-items:center; gap:10px; margin-bottom:44px; }
.auth-logo-icon { width:38px; height:38px; background:#0078F2; border-radius:8px; display:flex; align-items:center; justify-content:center; font-size:19px; }
.auth-logo-name { font-size:18px; font-weight:800; color:#fff; letter-spacing:-0.3px; }
.auth-logo-name span { color:#0078F2; }

.auth-card { background:#1a1a1a; border:1px solid rgba(255,255,255,0.08); border-radius:12px; padding:36px; animation:cardIn 0.35s cubic-bezier(0.16,1,0.3,1); }
@keyframes cardIn { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
.auth-card-title { font-size:22px; font-weight:800; color:#fff; letter-spacing:-0.5px; margin-bottom:5px; }
.auth-card-sub   { font-size:14px; color:#6b6b6b; margin-bottom:24px; }

/* Benefits tags */
.benefits-row { display:flex; gap:6px; flex-wrap:wrap; margin-bottom:24px; }
.b-tag { font-size:11px; font-weight:600; color:#0078F2; background:rgba(0,120,242,0.08); border:1px solid rgba(0,120,242,0.18); border-radius:4px; padding:4px 10px; }

/* Fields */
.field { margin-bottom:16px; }
.field-label { display:block; font-size:12px; font-weight:600; color:#6b6b6b; margin-bottom:7px; }
.input-wrap { position:relative; }
.field-inp { width:100%; background:#121212; border:1px solid rgba(255,255,255,0.1); border-radius:8px; padding:12px 15px; font-family:'Inter',sans-serif; font-size:14px; color:#fff; outline:none; transition:all 0.15s; }
.field-inp:focus { border-color:#0078F2; background:rgba(0,120,242,0.04); box-shadow:0 0 0 3px rgba(0,120,242,0.1); }
.field-inp::placeholder { color:#3a3a3a; }
.field-inp.pr { padding-right:46px; }
.field-inp.match    { border-color:rgba(34,197,94,0.5); }
.field-inp.no-match { border-color:rgba(239,68,68,0.4); }
.pw-toggle { position:absolute; right:13px; top:50%; transform:translateY(-50%); background:none; border:none; color:#4a4a4a; cursor:pointer; font-size:15px; padding:2px; transition:color 0.15s; }
.pw-toggle:hover { color:#a3a3a3; }
.field-hint { font-size:11px; margin-top:5px; font-weight:500; }

/* Field 2-col */
.field-row { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
@media(max-width:480px){ .field-row { grid-template-columns:1fr; } }

/* Strength bar */
.strength-bar { display:flex; gap:3px; margin-top:7px; }
.str-seg { flex:1; height:3px; border-radius:2px; background:rgba(255,255,255,0.07); transition:background 0.25s; }

/* Alert */
.alert { display:flex; align-items:flex-start; gap:10px; padding:12px 14px; border-radius:8px; font-size:13px; font-weight:500; margin-bottom:16px; }
.alert-error { background:rgba(239,68,68,0.08); border:1px solid rgba(239,68,68,0.2); color:#f87171; }

/* Submit */
.btn-submit { width:100%; padding:14px; background:#0078F2; border:none; border-radius:8px; font-family:'Inter',sans-serif; font-size:15px; font-weight:700; color:#fff; cursor:pointer; transition:all 0.15s; margin-top:8px; }
.btn-submit:hover { background:#0a84ff; transform:translateY(-1px); }
.btn-submit:active { transform:translateY(0); }
.btn-submit:disabled { background:#2a2a2a; color:#4a4a4a; cursor:not-allowed; transform:none; }

.terms-text { font-size:11px; color:#3a3a3a; text-align:center; margin-top:12px; line-height:1.6; }
.auth-footer { text-align:center; margin-top:18px; font-size:14px; color:#6b6b6b; }
.auth-footer a { color:#0078F2; text-decoration:none; font-weight:600; }
.auth-footer a:hover { color:#0a84ff; }

/* Right panel */
.auth-right { width:420px; flex-shrink:0; background:#0d1118; border-left:1px solid rgba(255,255,255,0.06); display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px; position:relative; overflow:hidden; }
.auth-right-glow { position:absolute; bottom:-10%; right:-10%; width:70%; padding-top:70%; background:radial-gradient(circle, rgba(0,120,242,0.12) 0%,transparent 70%); pointer-events:none; }
.auth-right-content { position:relative; z-index:2; text-align:center; }
.auth-right-heading { font-size:26px; font-weight:900; color:#fff; letter-spacing:-0.8px; margin-bottom:10px; line-height:1.2; }
.auth-right-heading span { color:#0078F2; }
.auth-right-sub { font-size:14px; color:#4a4a4a; line-height:1.7; max-width:280px; margin:0 auto 40px; }
.stats-grid { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
.stat-box { background:rgba(255,255,255,0.04); border:1px solid rgba(255,255,255,0.07); border-radius:10px; padding:20px 16px; text-align:center; }
.stat-n { font-size:28px; font-weight:900; color:#0078F2; margin-bottom:4px; }
.stat-l { font-size:11px; font-weight:500; color:#4a4a4a; text-transform:uppercase; letter-spacing:0.8px; }

@media(max-width:900px){ .auth-right { display:none; } }
@media(max-width:480px){ .auth-left { padding:24px 16px; } .auth-card { padding:24px 18px; } }
`;

export default function Register() {
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail]             = useState("");
  const [password, setPassword]       = useState("");
  const [confirm, setConfirm]         = useState("");
  const [error, setError]             = useState("");
  const [loading, setLoading]         = useState(false);
  const [showPw, setShowPw]           = useState(false);

  function getStrength(pw) {
    let s = 0;
    if (pw.length >= 8) s++;
    if (/[A-Z]/.test(pw)) s++;
    if (/[0-9]/.test(pw)) s++;
    if (/[^A-Za-z0-9]/.test(pw)) s++;
    return s;
  }
  const strength = getStrength(password);
  const strColors = ["","#ef4444","#eab308","#0078F2","#22c55e"];
  const strLabels = ["","Weak","Fair","Good","Strong"];

  async function handleRegister(e) {
    e.preventDefault(); setError("");
    if (!displayName.trim()) return setError("Please enter your name.");
    if (password.length < 6) return setError("Password must be at least 6 characters.");
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    try { await register(email, password, displayName.trim()); navigate("/", { replace:true }); }
    catch (err) { setError(getFriendlyError(err.code)); }
    finally { setLoading(false); }
  }

  function getFriendlyError(code) {
    switch(code) {
      case "auth/email-already-in-use": return "This email is already registered. Try logging in.";
      case "auth/invalid-email":        return "Please enter a valid email address.";
      case "auth/weak-password":        return "Password is too weak. Use at least 6 characters.";
      default: return "Registration failed. Please try again.";
    }
  }

  return (
    <>
      <style>{S}</style>
      <div className="auth-pg">
        <div className="auth-left">
          <div className="auth-left-bg" />
          <div className="auth-left-grid" />
          <div className="auth-left-glow" />
          <div className="auth-left-content">
            <div className="auth-logo">
              <div className="auth-logo-icon">🎮</div>
              <div className="auth-logo-name">Phsar<span>Game</span></div>
            </div>

            <div className="auth-card">
              <div className="auth-card-title">Create your account</div>
              <div className="auth-card-sub">Join PhsarGame and start playing today</div>

              <div className="benefits-row">
                <span className="b-tag">⚡ Instant Delivery</span>
                <span className="b-tag">🎮 100+ Games</span>
                <span className="b-tag">💬 24/7 Support</span>
              </div>

              {error && <div className="alert alert-error">⚠️ {error}</div>}

              <form onSubmit={handleRegister}>
                <div className="field">
                  <label className="field-label">Your name</label>
                  <input className="field-inp" type="text" placeholder="Dara Chan" value={displayName} onChange={e=>setDisplayName(e.target.value)} required autoComplete="name" />
                </div>
                <div className="field">
                  <label className="field-label">Email address</label>
                  <input className="field-inp" type="email" placeholder="your@email.com" value={email} onChange={e=>setEmail(e.target.value)} required autoComplete="email" />
                </div>

                <div className="field-row">
                  <div className="field">
                    <label className="field-label">Password</label>
                    <div className="input-wrap">
                      <input className="field-inp pr" type={showPw?"text":"password"} placeholder="••••••••" value={password} onChange={e=>setPassword(e.target.value)} required autoComplete="new-password" />
                      <button type="button" className="pw-toggle" onClick={()=>setShowPw(!showPw)}>{showPw?"🙈":"👁️"}</button>
                    </div>
                    {password && (
                      <>
                        <div className="strength-bar">
                          {[1,2,3,4].map(i => <div key={i} className="str-seg" style={{background: i<=strength ? strColors[strength] : undefined}} />)}
                        </div>
                        <div className="field-hint" style={{color:strColors[strength]}}>{strLabels[strength]}</div>
                      </>
                    )}
                  </div>
                  <div className="field">
                    <label className="field-label">Confirm</label>
                    <input className={`field-inp ${confirm ? (confirm===password?"match":"no-match") : ""}`} type={showPw?"text":"password"} placeholder="••••••••" value={confirm} onChange={e=>setConfirm(e.target.value)} required autoComplete="new-password" />
                    {confirm && <div className="field-hint" style={{color:confirm===password?"#22c55e":"#ef4444"}}>{confirm===password?"✓ Match":"✗ No match"}</div>}
                  </div>
                </div>

                <button type="submit" className="btn-submit" disabled={loading}>
                  {loading ? "Creating account…" : "Create Account →"}
                </button>
              </form>

              <div className="terms-text">By creating an account, you agree to our Terms of Service and understand that Steam accounts are for offline use only.</div>
              <div className="auth-footer">Already have an account? <Link to="/login">Sign in</Link></div>
            </div>
          </div>
        </div>

        <div className="auth-right">
          <div className="auth-right-glow" />
          <div className="auth-right-content">
            <div className="auth-right-heading">Premium Games at<br /><span>Cambodian</span> Prices</div>
            <div className="auth-right-sub">Join hundreds of Cambodian gamers already playing premium titles for a fraction of the cost.</div>
            <div className="stats-grid">
              {[["100+","Games"],["500+","Customers"],["$2.99","From USD"],["24/7","Support"]].map(([n,l]) => (
                <div key={l} className="stat-box"><div className="stat-n">{n}</div><div className="stat-l">{l}</div></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}